/**
 * 由于后台管理系统不支持，放弃原本的 动态路由配置，采用本地路由
 * **/

export const Workbench = [
  {
    path: "/workbench",
    name: "Workbench",
    component: () => import("@/views/workbench/index"),
    meta: {
      name: "工作台",
      isMenu: true,
      keepAlive: false,
      parentId: "008001",
    },
  },
];
export const inHouse = [
  // 入库
  {
    path: "/inHouse_receipt",
    name: "Receipt",
    // filePath: 'inHouse/receipt',
    component: () => import("@/views/inHouse/receipt"),
    meta: {
      name: "物流签收",
      isMenu: true,
      keepAlive: true,
      parentId: "008002",
    },
  },
  {
    path: "/inHouse_check",
    name: "Check",
    // filePath: 'inHouse/check',
    component: () => import("@/views/inHouse/check"),
    meta: {
      name: "简单检品",
      isMenu: true,
      keepAlive: false,
      parentId: "008002",
    },
  },
  {
    path: "/inHouse_recheck",
    name: "ReCheck",
    // filePath: 'inHouse/check',
    component: () => import("@/views/inHouse/recheck"),
    meta: {
      name: "复检",
      isMenu: true,
      keepAlive: false,
      parentId: "008002",
    },
  },
  {
    path: "/inHouse_newProductCheck",
    name: "NewProductCheck",
    // filePath: 'inHouse/check',
    component: () => import("@/views/inHouse/newProductCheck/newProductCheck"),
    meta: {
      name: "新品测量",
      isMenu: true,
      keepAlive: false,
      parentId: "008002",
    },
  },
  {
    path: "/inHouse_createTransfer",
    name: "CreateTransfer",
    // filePath: 'inHouse/createTransfer',
    component: () => import("@/views/inHouse/createTransfer"),
    meta: {
      name: "移库",
      isMenu: true,
      keepAlive: true,
      parentId: "008002",
    },
  },
  {
    path: "/inHouse_shiftConfirm",
    name: "shiftConfirm",
    // filePath: 'inHouse/shiftConfirm',
    component: () => import("@/views/inHouse/shiftConfirm"),
    meta: {
      name: "移库确认",
      isMenu: true,
      keepAlive: true,
      parentId: "008002",
    },
  },
  {
    path: "/inHouse_inboundOrder",
    name: "inboundOrder",
    // filePath: 'inHouse/shiftConfirm',
    component: () => import("@/views/inHouse/inboundOrder/index"),
    meta: {
      name: "入库单管理",
      isMenu: true,
      keepAlive: true,
      parentId: "008002",
    },
  },
  {
    path: "/inHouse_inboundDetail",
    name: "inboundDetail",
    // filePath: 'inHouse/shiftConfirm',
    component: () => import("@/views/inHouse/inboundDetail/inboundDetail"),
    meta: {
      name: "入库单详情",
      isMenu: false,
      keepAlive: true,
      parentId: "008002",
    },
  },
  {
    path: "/inHouse_log",
    name: "log",
    // filePath: 'inHouse/shiftConfirm',
    component: () => import("@/views/inHouse/logHistory/index"),
    meta: {
      name: "操作日志",
      isMenu: false,
      keepAlive: true,
      parentId: "008002",
    },
  },
];
export const checking = [
  // 检品
  {
    path: "/checking_washingLabelRequire",
    name: "WashingLabelRequire",
    // filePath: 'checking/washingLabelRequire',
    component: () => import("@/views/checking/washingLabelRequire"),
    meta: {
      name: "水洗标要求",
      isMenu: true,
      keepAlive: true,
      parentId: "008003",
    },
  },
  {
    path: "/checking_QCRequire",
    name: "QCRequire",
    // filePath: 'checking/QCRequire',
    component: () => import("@/views/checking/QCRequire"),
    meta: {
      name: "质检要求",
      isMenu: true,
      keepAlive: true,
      parentId: "008003",
    },
  },
  {
    path: "/checking_RepairRecord",
    name: "QCRequire",
    // filePath: 'checking/QCRequire',
    component: () => import("@/views/checking/RepairRecord"),
    meta: {
      name: "修复记录",
      isMenu: true,
      keepAlive: true,
      parentId: "008003",
    },
  },
];
export const assemble = [
  // 组合列表
  {
    path: "/assemble_list",
    name: "assemble_list",
    component: () => import("@/views/assemble/List.vue"),
    meta: {
      name: "组合列表",
      isMenu: true,
      keepAlive: true,
      parentId: "008004",
    },
  },
  // 质检上架
  {
    path: "/assemble_QIShelves",
    name: "assemble_QIShelves",
    component: () => import("@/views/assemble/QIShelves"),
    meta: {
      name: "组合列表",
      isMenu: true,
      keepAlive: true,
      parentId: "008004",
    },
  },
];
export const abnormal = [
  // 异常
  {
    path: "/abnormal_list",
    name: "abnormal_list",
    component: () => import("@/views/abnormal/list/List"),
    meta: {
      name: "异常列表",
      isMenu: true,
      keepAlive: true,
      parentId: "008005",
    },
  },
  {
    path: "/abnormal_package",
    name: "abnormal_package",
    component: () => import("@/views/abnormal/package/index"),
    meta: {
      name: "异常包裹列表",
      isMenu: true,
      keepAlive: true,
      parentId: "008005",
    },
  },
  {
    path: "/abnormal_listDetail",
    name: "abnormal_listDetail",
    component: () => import("@/views/abnormal/listDetail/ListDetail"),
    meta: {
      name: "异常详情",
      isMenu: true,
      keepAlive: true,
      parentId: "008005",
    },
  },
  {
    path: "/abnormal_unpacking",
    name: "abnormal_unpacking",
    component: () => import("@/views/abnormal/unpacking/Unpacking"),
    meta: {
      name: "拆包新增异常",
      isMenu: true,
      keepAlive: true,
      parentId: "008005",
    },
  },
  {
    path: "/abnormal_warehouse",
    name: "abnormal_warehouse",
    component: () => import("@/views/abnormal/warehouse/Warehouse"),
    meta: {
      name: "库内异常",
      isMenu: true,
      keepAlive: true,
      parentId: "008005",
    },
  },
  {
    path: "/abnormal_defectiveProducts",
    name: "abnormal_defectiveProducts",
    component: () => import("@/views/abnormal/defective/DefectiveProducts"),
    meta: {
      name: "次品记录",
      isMenu: true,
      keepAlive: true,
      parentId: "008005",
    },
  },
  {
    path: "/abnormal_regularization",
    name: "abnormal_regularization",
    component: () => import("@/views/abnormal/regularization/index"),
    meta: {
      name: "次品转正品管理",
      isMenu: true,
      keepAlive: true,
      parentId: "008005",
    },
  }
];
export const outOfStock = [
  // 审单
  {
    path: "/outOfStock_review",
    name: "Review",
    // filePath: 'outOfStock/internationalShipment/index',
    component: () => import("@/views/outOfStock/review/index"),
    meta: {
      name: "国际发货审单",
      isMenu: true,
      keepAlive: true,
      parentId: "008006",
    },
  },
  // 可制发票列表
  {
    path: "/outOfStock_manufacturableInvoiceList",
    name: "ManufacturableInvoiceList",
    // filePath: 'outOfStock/internationalShipment/index',
    component: () => import("@/views/outOfStock/manufacturableInvoiceList/index"),
    meta: {
      name: "可制发票列表",
      isMenu: true,
      keepAlive: true,
      parentId: "008006",
    },
  },
  // 出库
  {
    path: "/outOfStock_internationalShipment",
    name: "InternationalInvoice",
    // filePath: 'outOfStock/internationalShipment/index',
    component: () => import("@/views/outOfStock/internationalShipment/index"),
    meta: {
      name: "国际发货单",
      isMenu: true,
      keepAlive: true,
      parentId: "008006",
    },
  },
  {
    path: "/outOfStock_waveManage",
    name: "WaveManage",
    // filePath: 'outOfStock/internationalShipment/index',
    component: () => import("@/views/outOfStock/waveManage/index"),
    meta: {
      name: "波次管理",
      isMenu: true,
      keepAlive: true,
      parentId: "008006",
    },
  },
  {
    path: "/outOfStock_smallSingleBuilding",
    name: "SmallSingleBuilding",
    // filePath: 'outOfStock/smallSingleBuilding/index',
    component: () => import("@/views/outOfStock/smallSingleBuilding/index"),
    meta: {
      name: "小件单品打包",
      isMenu: true,
      keepAlive: true,
      parentId: "008006",
    },
  },
  {
    path: "/outOfStock_smallHotBatchBuilding",
    name: "SmallSingleBuilding",
    // filePath: 'outOfStock/smallSingleBuilding/index',
    component: () => import("@/views/outOfStock/smallHotBatchBuilding/index"),
    meta: {
      name: "小件单品批量打包",
      isMenu: true,
      keepAlive: true,
      parentId: "008006",
    },
  },
  {
    path: "/outOfStock_smallMultiSowing",
    name: "SmallMultiSowing",
    // filePath: 'outOfStock/smallMultiSowing/index',
    component: () => import("@/views/outOfStock/smallMultiSowing/index"),
    meta: {
      name: "小件多品播种",
      isMenu: true,
      keepAlive: true,
      parentId: "008006",
    },
  },
  {
    path: "/outOfStock_smallMultiBuilding",
    name: "SmallMultiBuilding",
    // filePath: 'outOfStock/smallMultiBuilding/index',
    component: () => import("@/views/outOfStock/smallMultiBuilding/index"),
    meta: {
      name: "小件多品打包",
      isMenu: true,
      keepAlive: true,
      parentId: "008006",
    },
  },
  {
    path: "/outOfStock_largeBagMark",
    name: "LargeBagMark",
    // filePath: 'outOfStock/largeBagMark/index',
    component: () => import("@/views/outOfStock/largeBagMark/index"),
    meta: {
      name: "大件打标",
      isMenu: true,
      keepAlive: true,
      parentId: "008006",
    },
  },
  {
    path: "/outOfStock_largeBagPackage",
    name: "LargeBagPackage",
    // filePath: 'outOfStock/largeBagPackage/index',
    component: () => import("@/views/outOfStock/largeBagPackage/index"),
    meta: {
      name: "大件装箱",
      isMenu: true,
      keepAlive: true,
      parentId: "008006",
    },
  },
  {
    path: "/outOfStock_FBABagPackage",
    name: "FBABagPackage",
    // filePath: 'outOfStock/largeBagPackage/index',
    component: () => import("@/views/outOfStock/FBABagPackage/index"),
    meta: {
      name: "FBA装箱",
      isMenu: true,
      keepAlive: true,
      parentId: "008006",
    },
  },
  {
    path: "/outOfStock_internationalShipment_details_shipInvoice",
    name: "shipInvoiceDetails",
    // filePath: 'outOfStock/internationalShipment/details/shipInvoice',
    component: () =>
      import("@/views/outOfStock/internationalShipment/details/shipInvoice"),
    props: true,
    meta: {
      name: "发货单详情",
      isMenu: false,
      keepAlive: true,
      parentId: "008006",
    },
  },
  {
    path: "/outOfStock_internationalShipment_details_goods",
    name: "goodsDetails",
    // filePath: 'outOfStock/internationalShipment/details/goods',
    component: () =>
      import("@/views/outOfStock/internationalShipment/details/goods"),
    props: true,
    meta: {
      name: "商品详情",
      isMenu: false,
      keepAlive: true,
      parentId: "008006",
    },
  },
];
export const inventoryDetails = [
  // 库存详情
  {
    path: "/inventoryDetails_warehouseStatus",
    name: "WarehouseStatus",
    // filePath: 'inventoryDetails/warehouseStatus/index',
    component: () => import("@/views/inventoryDetails/warehouseStatus/index"),
    meta: {
      name: "仓库状态",
      isMenu: true,
      keepAlive: true,
      parentId: "008007",
    },
  },
  {
    path: "/inventoryDetails_receiptLog",
    name: "ReceiptLog",
    // filePath: 'inventoryDetails/receiptLog/index',
    component: () => import("@/views/inventoryDetails/receiptLog/index"),

    meta: {
      name: "快递签收记录",
      isMenu: true,
      keepAlive: true,
      parentId: "008007",
    },
  },
  {
    path: "/inventoryDetails_inventory",
    name: "Inventory",
    // filePath: 'inventoryDetails/inventory/index',
    component: () => import("@/views/inventoryDetails/inventory/index"),

    meta: {
      name: "仓库库存",
      isMenu: true,
      keepAlive: true,
      parentId: "008007",
    },
  },
  // {
  //   path: "/inventoryDetails_boxInventory",
  //   name: "BoxInventory",
  //   component: () => import("@/views/inventoryDetails/boxInventory/index"),

  //   meta: {
  //     name: "箱子库存",
  //     isMenu: true,
  //     keepAlive: true,
  //     parentId: '008007'
  //   },
  // },
  {
    path: "/inventoryDetails_transferLedger",
    name: "TransferLedger",
    // filePath: 'inventoryDetails/transferLedger/index',
    component: () => import("@/views/inventoryDetails/transferLedger/index"),

    meta: {
      name: "移库台账",
      isMenu: true,
      keepAlive: true,
      parentId: "008007",
    },
  },
  {
    path: "/inventoryDetails_assist",
    name: "Assist",
    // filePath: 'inventoryDetails/assist/index',
    component: () => import("@/views/inventoryDetails/assist/index"),

    meta: {
      name: "辅料",
      isMenu: true,
      keepAlive: true,
      parentId: "008007",
    },
  },
  {
    path: "/inventoryDetails_discard",
    name: "Discard",
    // filePath: 'inventoryDetails/discard/index',
    component: () => import("@/views/inventoryDetails/discard/index"),

    meta: {
      name: "废弃件",
      isMenu: true,
      keepAlive: true,
      parentId: "008007",
    },
  },
  {
    path: "/inventoryDetails_lost",
    name: "Lost",
    // filePath: 'inventoryDetails/lost/index',
    component: () => import("@/views/inventoryDetails/lost/index"),
    meta: {
      name: "丢件列表",
      isMenu: true,
      keepAlive: true,
      parentId: "008007",
    },
  },
  {
    path: "/inventoryDetails_flow",
    name: "inventoryDetails_flow",
    // filePath: 'inventoryDetails/lost/index',
    component: () => import("@/views/inventoryDetails/flow/index"),
    meta: {
      name: "库存流水",
      isMenu: true,
      keepAlive: true,
      parentId: "008007",
    },
  },
];
export const report = [
  // 数据导出
  {
    path: "/statement_export",
    name: "Export",
    component: () => import("@/views/statement/export/index"),
    meta: {
      name: "数据导出",
      isMenu: false,
      keepAlive: true,
      parentId: "008008",
    },
  },
  // 报表
  {
    path: "/statement_overall",
    name: "statement_overall",
    component: () => import("@/views/statement/Overall"),
    meta: {
      name: "总览数据统计",
      isMenu: false,
      keepAlive: true,
      parentId: "008008",
    },
  },
  {
    path: "/statement_storageAreas",
    name: "statement_storageAreas",
    component: () => import("@/views/statement/StorageAreas"),
    meta: {
      name: "仓储各库区商品统计",
      isMenu: false,
      keepAlive: true,
      parentId: "008008",
    },
  },
  {
    path: "/statement_simpleInspection",
    name: "statement_simpleInspection",
    component: () => import("@/views/statement/SimpleInspection"),
    meta: {
      name: "简单检品统计表",
      isMenu: false,
      keepAlive: true,
      parentId: "008008",
    },
  },
  {
    path: "/statement_transfersNumber",
    name: "statement_transfersNumber",
    component: () => import("@/views/statement/TransfersNumber"),
    meta: {
      name: "移库数量统计",
      isMenu: false,
      keepAlive: true,
      parentId: "008008",
    },
  },
  {
    path: "/statement_picking",
    name: "statement_picking",
    component: () => import("@/views/statement/Picking"),
    meta: {
      name: "检货统计",
      isMenu: false,
      keepAlive: true,
      parentId: "008008",
    },
  },
  {
    path: "/statement_shelvesNumber",
    name: "statement_shelvesNumber",
    component: () => import("@/views/statement/ShelvesNumber"),
    meta: {
      name: "上架数量统计",
      isMenu: false,
      keepAlive: true,
      parentId: "008008",
    },
  },
  {
    path: "/statement_QI",
    name: "statement_QI",
    component: () => import("@/views/statement/QI"),
    meta: {
      name: "质检相关数据统计",
      isMenu: false,
      keepAlive: true,
      parentId: "008008",
    },
  },
  {
    path: "/statement_excipientStock",
    name: "statement_excipientStock",
    component: () => import("@/views/statement/ExcipientStock"),
    meta: {
      name: "辅料库存",
      isMenu: false,
      keepAlive: true,
      parentId: "008008",
    },
  },
];
export const warehouseConfig = [
  // 仓库配置
  {
    path: "/configure_warehouse",
    name: "ConfigureWarehouse",
    component: () => import("@/views/configure/warehouse/index"),
    meta: {
      name: "仓库配置",
      isMenu: true,
      keepAlive: true,
      parentId: "008009",
    },
  },
  {
    path: "/configure_box",
    name: "ConfigureBox",
    component: () => import("@/views/configure/box/index"),
    meta: {
      name: "箱子配置",
      isMenu: true,
      keepAlive: true,
      parentId: "008009",
    },
  },
  {
    path: "/configure_basket",
    name: "ConfigureBasket",
    component: () => import("@/views/configure/basket/index"),
    meta: {
      name: "分拣框配置",
      isMenu: true,
      keepAlive: true,
      parentId: "008009",
    },
  },
  {
    path: "/configure_gridCode",
    name: "ConfigureGridCode",
    component: () => import("@/views/configure/gridCode/index"),
    meta: {
      name: "库位配置",
      isMenu: true,
      keepAlive: true,
      parentId: "008009",
    },
  },
  {
    path: "/configure_labelTemplate",
    name: "ConfigureLabelTemplate",
    component: () => import("@/views/configure/labelTemplate/index"),
    meta: {
      name: "打印标签配置",
      isMenu: true,
      keepAlive: true,
      parentId: "008009",
    },
  },
  {
    path: "/configure_addTemplate",
    name: "ConfigureAddTemplate",
    component: () => import("@/views/configure/labelTemplate/addTemplate"),
    meta: {
      name: "配置模版",
      isMenu: true,
      keepAlive: true,
      parentId: "008009",
    },
  },
  {
    path: "/configure_shipWeightFree",
    name: "ConfigureShipWeightFree",
    component: () => import("@/views/configure/shipWeightFree/index"),
    meta: {
      name: "发货重量费用配置",
      isMenu: true,
      keepAlive: true,
      parentId: "008009",
    },
  },
  {
    path: "/configure_WarehouseArea",
    name: "ConfigureWarehouseArea",
    component: () => import("@/views/configure/warehouseArea/index"),
    meta: {
      name: "库区配置",
      isMenu: true,
      keepAlive: true,
      parentId: "008009",
    },
  },
  {
    path: "/configure_logisticsConfig",
    name: "Configure_logisticsConfig",
    component: () => import("@/views/configure/logisticsConfig/index"),
    meta: {
      name: "物流API关联配置",
      isMenu: true,
      keepAlive: true,
      parentId: "008009",
    },
  },
  {
    path: "/configure_defaultTemplate",
    name: "configure_defaultTemplate",
    component: () => import("@/views/configure/defaultTemplate/index"),
    meta: {
      name: "默认标签配置",
      isMenu: true,
      keepAlive: true,
      parentId: "008009",
    },
  },
  {
    path: "/configure_printerConfig",
    name: "configure_printerConfig",
    component: () => import("@/views/configure/printerConfig/index"),
    meta: {
      name: "打印机匹配配置",
      isMenu: true,
      keepAlive: true,
      parentId: "008009",
    },
  },
  {
    path: "/configure_container",
    name: "configure_container",
    component: () => import("@/views/configure/container/index"),
    meta: {
      name: "容器配置",
      isMenu: true,
      keepAlive: true,
      parentId: "008009",
    },
  },
];
export const conbination = [
  // 组合
  {
    path: "/combination_list",
    name: "combinationList",
    component: () => import("@/views/combination/list/index"),
    meta: {
      name: "组合列表",
      isMenu: true,
      keepAlive: true,
      parentId: "008004",
    },
  },
  {
    path: "/combination_putShelf",
    name: "combinationPutShelf",
    component: () => import("@/views/combination/putShelf/index"),
    meta: {
      name: "质检上架",
      isMenu: true,
      keepAlive: true,
      parentId: "008004",
    },
  },
  {
    path: "/combination_combination",
    name: "combination",
    component: () => import("@/views/combination/combination/index"),
    meta: {
      name: "组合",
      isMenu: true,
      keepAlive: true,
      parentId: "008004",
    },
  },
  {
    path: "/combination_sortBox",
    name: "sortBox",
    component: () => import("@/views/combination/sortBox/index"),
    meta: {
      name: "组合分拣框",
      isMenu: true,
      keepAlive: true,
      parentId: "008004",
    },
  },
];
export const outOfDomestic = [
  //国内发货
  {
    path: "/outOfDomestic_domesticShipment",
    name: "domesticShipment",
    component: () => import("@/views/outOfDomestic/domesticShipment/index"),
    meta: {
      name: "国内发货单",
      isMenu: true,
      keepAlive: true,
      parentId: "008010",
    },
  },
  {
    path: "/outOfDomestic_transferConfirm",
    name: "transferConfirm",
    // filePath: 'inHouse/transferConfirm',
    component: () => import("@/views/outOfDomestic/transferConfirm/index"),
    meta: {
      name: "调拨单确认",
      isMenu: true,
      keepAlive: true,
      parentId: "008010",
    },
  },
  {
    path: "/outOfDomestic_addPkg",
    name: "addPkg",
    // filePath: 'inHouse/transferConfirm',
    component: () => import("@/views/outOfDomestic/addPkg/index"),
    meta: {
      name: "添加发货单",
      isMenu: true,
      keepAlive: false,
      parentId: "008010",
    },
  },
];
let allRoutes = [
  ...Workbench,
  ...inHouse,
  ...checking,
  ...assemble,
  ...abnormal,
  ...outOfStock,
  ...inventoryDetails,
  ...report,
  ...warehouseConfig,
  ...conbination,
  ...outOfDomestic,
];

export default allRoutes;
